export default "__VITE_ASSET__C3K_6DWS__"